import type { IntlShape } from 'react-intl';

import type { ICertificateItemTemplate } from '@share/common-types';
import { ItemTypeEnum } from '@share/common-types';

import { itemTypeMessageId } from './components/certificate-item-tag/utils';

import DefaultImage from '@assets/images/certificates/hotel.png';

const AVERAGE_PRICE_TYPE_ORDER: ItemTypeEnum[] = [
  ItemTypeEnum.Hotel,
  ItemTypeEnum.Cruise,
  ItemTypeEnum.Condo,
];

export const getCertificateImageSrc = (
  imageUrl: string | null | undefined,
  hasImageError: boolean,
): string => (imageUrl && !hasImageError ? imageUrl : DefaultImage);

export const getAveragePriceLabel = (
  intl: IntlShape,
  itemTemplates: ICertificateItemTemplate[],
): string | null => {
  const presentTypes = new Set(itemTemplates.map((template) => template.type));
  const orderedTypes = AVERAGE_PRICE_TYPE_ORDER.filter((type) => presentTypes.has(type));

  if (orderedTypes.length === 0) {
    return null;
  }

  const types = orderedTypes
    .map((type) => intl.formatMessage({ id: itemTypeMessageId(type) }))
    .join('+');

  return intl.formatMessage({ id: 'certificates.card.averagePrice' }, { types });
};
